import React from "react";
import ViewSwitchTab from "./ViewSwitchTab";
import LaunchBoxLinksTab from "./LaunchBoxLinksTab";
import ConsolesTab from "./ConsolesTab";

const VIEWS = [
  { key: "games", label: "Games", component: LaunchBoxLinksTab },
  { key: "consoles", label: "Consoles", component: ConsolesTab },
];

// What the app has opened from the LaunchBox catalog: games (games_launchbox) and
// consoles (consoles_launchbox).
function LaunchBoxTab(props) {
  return <ViewSwitchTab kicker="Curated source" title="LaunchBox" label="LaunchBox view" views={VIEWS} {...props} />;
}

export default LaunchBoxTab;
